import Vue from 'vue'

const state = {
  mensagem: null,
  modal: false,
  conferencia: null,
  conferenciasRelacionadas: [],
  configurarConferencia: null
}

const mutations = {
  setMensagemConferencia (state, data) {
    state.mensagem = data
  },
  setConferencia (state, data) {
    state.conferencia = data
  },
  setConferenciasRelacionadas (state, data) {
    state.conferenciasRelacionadas = data
  },
  setConfigurarConferencia (state, data) {
    state.configurarConferencia = data
  },
  setModal (state, data) {
    state.modal = data
  }
}

const getters = {
  getConfigurarConferencia: state => {
    return state.configurarConferencia
  }
}

const actions = {
  setConferencia ({commit}, conferencia) {
    commit('setConferencia', conferencia)
  },
  setConferenciasRelacionadas ({commit}, conferencia) {
    Vue.http.get('api/conferencia/relacionadas/' + conferencia).then(response => {
      commit('setConferenciasRelacionadas', response.data.data)
    })
  },
  setListaConferenciasRelacionadas ({commit}, conferencia) {
    Vue.http.get('api/conferencia/relacionadas/' + conferencia).then(response => {
      let data = response.data.data
      let conferencias = []

      for(let i in data) {
        conferencias.push({
          'value': data[i].id,
          'text': data[i].nome
        })
      }
      commit('setConferenciasRelacionadas', conferencias)
    })
  },
  setConfigurarConferencia ({commit}, configurarConferencia) {
    commit('setConfigurarConferencia', configurarConferencia)
  },
  setModalConferencia ({commit}, modal) {
    commit('setModal', modal)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/conferencia.js